<template>
  <Dropdown
    :position="position"
    :y-offset="yOffset"
    :button-class="buttonClass"
    :button-content-class="buttonContentClass"
    :fullscreen="fullscreen"
    :chevron-size="chevronSize"
    :hint="hint"
    @opened="dropdownOpened"
  >
    <template #label-icon>
      <slot name="current-option-icon" :option="currentOption"> </slot>
    </template>
    <template #label>
      <slot name="current-option" :option="currentOption"> </slot>
    </template>
    <template #chevron>
      <slot name="chevron"> </slot>
    </template>
    <template #title>
      <slot name="title"> </slot>
    </template>
    <template #content="{ closeDropdown }">
      <ul ref="select">
        <li
          v-for="(option, index) in options"
          :key="index"
          :inert="option.id === currentOption.id"
          class="select-item group/select-item border-1 flex h-9 cursor-pointer items-center rounded-lg px-2 py-1.5 transition-colors hover:bg-gray-100 dark:hover:bg-neutral-800 md:h-8"
          :class="{
            'active border-primary': option.id === currentOption.id,
            'border-transparent': option.id !== currentOption.id,
          }"
          @click="
            updateValue(option);
            if (closeOnSelect) closeDropdown();
          "
        >
          <div
            class="group-[.active]/select-item:text-primary flex w-6 items-center justify-center"
          >
            <slot
              name="option-icon"
              :option="option"
              :index="index"
              :selected="option.id === currentOption.id"
            >
              <lucide-icon
                v-if="option.id === currentOption.id"
                icon="Check"
                size="16"
              />
              <lucide-icon
                v-else
                icon="Circle"
                size="8"
                class="text-gray-300 group-hover/select-item:text-gray-400 dark:text-neutral-700 dark:group-hover/select-item:text-neutral-600"
              />
            </slot>
          </div>
          <span class="truncate text-sm leading-4">
            <slot name="option" :option="option" :index="index"> </slot>
          </span>
        </li>
      </ul>
    </template>
  </Dropdown>
</template>

<script>
import Dropdown from './Dropdown';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Select',
  components: {
    Dropdown,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    position: {
      type: String,
      default: 'bottom-start',
    },
    yOffset: {
      type: Number,
      default: 5,
    },

    chevronSize: {
      type: Number,
      required: false,
    },
    buttonClass: {
      type: String,
      required: false,
    },
    buttonContentClass: {
      type: String,
      required: false,
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    fullscreen: {
      type: [Number, Boolean],
      default: false,
    },
    hint: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {};
  },

  computed: {
    currentOption: {
      get() {
        return this.value;
      },
      set(newOption) {
        this.$emit('input', newOption);
      },
    },
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    dropdownOpened() {
      this.$nextTick(() => {
        this.scrollToActive();
      });
    },
    scrollToActive() {
      const target = this.$refs.select.querySelector(`.select-item.active`);
      const container = this.$refs.select.closest('.custom-scroll-y');
      if (!target) {
        return;
      }
      const targetRect = target.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const offset =
        targetRect.top -
        containerRect.top +
        targetRect.height / 2 -
        containerRect.height / 2;

      container.scrollTo({
        top: container.scrollTop + offset,
        behavior: 'smooth',
      });
    },
    updateValue(value) {
      this.currentOption = value;
      if (!this.closeOnSelect) {
        this.$nextTick(() => {
          this.scrollToActive();
        });
      }
    },
  },
};
</script>
